namespace Matrix.Rebalancer {
    export interface OverlayAccountRow {
        AccountCode?: string;
        OverlayAccountCode?: string;
        OwnershipWeight?: number;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        AccountName?: string;
        AccountRowId?: number;
        OverlayAccountName?: string;
        OverlayAccountRowId?: number;
    }

    export namespace OverlayAccountRow {
        export const idProperty = 'RowId';
        export const nameProperty = 'AccountCode';
        export const localTextPrefix = 'Rebalancer.OverlayAccount';
        export const deletePermission = 'DataAdmin:Rebalancer';
        export const insertPermission = 'DataAdmin:Rebalancer';
        export const readPermission = 'Read:Rebalancer';
        export const updatePermission = 'DataAdmin:Rebalancer';

        export declare const enum Fields {
            AccountCode = "AccountCode",
            OverlayAccountCode = "OverlayAccountCode",
            OwnershipWeight = "OwnershipWeight",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            AccountName = "AccountName",
            AccountRowId = "AccountRowId",
            OverlayAccountName = "OverlayAccountName",
            OverlayAccountRowId = "OverlayAccountRowId"
        }
    }
}
